import { buildFieldSurfaceStyleFromKiot, type FieldSurfaceDefaults } from './types'

/** Base form nhập liệu (modal / popup). */
export const FORM_FIELD_SURFACE_STYLE = buildFieldSurfaceStyleFromKiot()

export const FORM_FIELD_SURFACE_DEFAULTS: FieldSurfaceDefaults = {
  labelLayout: 'above',
  size: 'medium',
  variant: 'outlined',
  fullWidth: true,
}
